// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .mb-4 {\r\n    margin-bottom: 1.5rem;\n}\n.swal-confirm-btn {\r\n    /* Adjust spacing as needed */\n}\n[dir=ltr] .swal-confirm-btn {\r\n    margin-right: 10px;\n}\n[dir=rtl] .swal-confirm-btn {\r\n    margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
